module.exports = __webpack_public_path__ + "images/qrcode-android-eafa83308710b90beed675d676fa1414.png";